<template>
  <div class="mobile-nav d-lg-none">
    <div>
      <b-button v-b-toggle.sidebar-right>
        <b-icon icon="justify"></b-icon>
      </b-button>
      <b-sidebar id="sidebar-right" bg-variant="dark" text-variant="light" right shadow>

        <item v-for="(item,index) in items"
              :key="index"
              :icon="item.icon"
              :item-class="`${item.name}-${$store.getters['User/isAdmin'] ? 'admin' : 'user'}`"
              :id="item.id"
              :name="item.name"
              :access="item.access"
              :action="item.action"
              :route="item.route"
              :children="item.children"></item>

      </b-sidebar>
    </div>
  </div>
</template>

<script>
import item from "./item";
export default {
  name: "mobile",
  components:{item},
  props:['items']
}
</script>

<style scoped>

ul li {
  list-style: none;
}


ul li a:focus {

  color: #7f9afd;

}

ul li a {
  color: #7f807d;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 15px;
  outline: none;
}
img {
  vertical-align: middle;
  border-style: none;
}

.main-nav > ul > li {
  position: relative;
  white-space: nowrap;
}

.main-nav a {
  display: block;
  position: relative;
  color: #131313;
  padding: 7px 20px;
  transition: 0.3s;
  font-size: 16px;

}

nav, section {
  display: block;
}
.mobile-nav{
  position: fixed;
  right:1rem;
  z-index: 10000;}


nav {
  display: block;
}

.mobile-nav a {
  z-index: 1000000;
  display: block;
  position: relative;
  color: #fff;
  padding: 10px 20px;
  font-weight: 500;
}


</style>